module.exports = __webpack_public_path__ + "img/img_zhidunshen.4ada0e1d.png";